import styled from 'styled-components';
import { Modal } from '@components/Modal';
import { fontStyle } from '@styles/common';

export const StyledTitle = styled.div`
  ${fontStyle('24px', '600')};
  font-family: 'Poppins', sans-serif;
`;

export const StyledMessage = styled.div`
  ${fontStyle('16px', '700')};
  margin-top: 8px;
  word-break: break-word;
  font-family: 'Poppins', sans-serif;
`;

export const StyledModal = styled(Modal)`
  & > div {
    z-index: 10000;
  }

  & > div:last-child {
    border: solid 5px #4c89ff;
    padding: 48px;
    background: #000000;
    color: #ffffff;
  }
`;
